angular.module('env.data',
    [
        'env.data.batching', // need to load before coupler (the later defined decorator will be executed first)
        'env.data.requestCoupler', // need to load before interceptors
        'env.data.httpInterceptors',
        'env.data.rest',

        'env.data.models',    // Model definitions
        'env.data.repos',      // Repositories
        'env.data.services'   // Services
    ])

    .config(function (restProvider) {
        restProvider.defaultConfig.setBaseUrl(om.config.build.baseUrl);
    })
;